import React from 'react';
import { Helmet } from 'react-helmet';
import TechStackVisualizer from './components/TechStackVisualizer';
// Page simplified to only Tech Stack per requirements

const TechnologyStackInfrastructure = () => {

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Tech Stack - Mirakalous</title>
        <meta name="description" content="Curated enterprise AI tech stack across cloud, on‑prem/HPC, frameworks, LLM serving, tooling, data & orchestration, vector search, DevOps/security, and datastores." />
        <meta name="keywords" content="Tech Stack, AI infrastructure, cloud, on‑prem, LLM serving, DevOps, data orchestration" />
      </Helmet>
      {/* Tech Stack (only required content) */}
      <section className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">Tech Stack</h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">Curated list of supported technologies across the categories you specified.</p>
          </div>
          <div className="glass-theme">
            <TechStackVisualizer />
          </div>
        </div>
      </section>
      {/* End simplified page */}
    </div>
  );
};

export default TechnologyStackInfrastructure;